<div class="resize-container-landing2 min-h-screen">
    <app-public-header
    [display]="displayHeader">
    </app-public-header>

    <div class="bg-surface-0 dark:bg-surface-950">
        <ng-content></ng-content>
    </div>

    <app-public-footer
    [display]="displayFooter">
    </app-public-footer>
</div>
